import './index.less';

/**
 * total<=7: 全部展示
 * total>7 :
 *   current<=4                    (1,2,3,4,5,……,total)
 *   current>4 && current<total-3  (1,……,current-1,current,current+1,……,total)
 *   current >=total-3             (1,……,total-4,total-3,total-2,total-1,total)
 */

export default {
  template: `
    <nav aria-label="Page navigation">
      <span class="page-total" v-if="showTotal">Total {{total}} pages</span>
      <ul class="pagination pagination-sm">
        <li v-if="current!=1" :class="current==1?'disabled':''">
          <span class="fa fa-angle-double-left" @click="select(1)"></span>
        </li>
        <li v-if="current!=1" :class="current==1?'disabled':''">
          <span class="fa fa-angle-left" @click="select(current-1)"></span>
        </li>
        <li v-for="page in pages" :class="{active: page.value==current }">
          <span @click="select(page.value)">{{page.text}}</span>
        </li>
        <li v-if="current!=total">
          <span class="fa fa-angle-right"  @click="select(current+1)"></span>
        </li>
        <li v-if="current!=total">
          <span class="fa fa-angle-double-right"  @click="select(total)"></span>
        </li>
      </ul>
    </nav>
  `,
  props:['current','total','showTotal'],

  methods:{
    select:function(page){
      // 通过 change 事件带出数值
      if(this.current==page) return;
      this.$emit('change', page);
    }
  },
  computed:{
    pages:function(){
      let list=[],total = this.total,current = this.current;
      if(total>7){
        if(current<=4){
          //(1,2,3,4,5,……,total)
          for(let i=1;i<=7;i++){
            let text = i,value=i;
            if(i==6) text='...';
            if(i==7) text = value = total;
            list.push({value,text});
          }
        }else if(current<total-3){
          //(1,……,current-1,current,current+1,……,total)
          for(let i=1;i<=7;i++){
            let text = value= current-4+i;
            if(i==1) text = value=1;
            if(i==2) text = '...';
            if(i==6) text = '...';
            if(i==7) text=value=total;
            list.push({value,text});
          }
        }else{ //current >=total-3
          //1,……,total-4,total-3,total-2,total-1,total
          for(let i=6;i>=0;i--){
            let text = value = total-i;
            if(i==6) text = value = 1;
            if(i==5) text = '...';
            list.push({value,text});
          }
        }
      }else{
        for(let i=1;i<=total;i++){
          list.push({
            value:i,
            text:i
          });
        }
      }
      return list;
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/page/index.js